import { useIsFetching } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import SectionHeader from 'components/sectionHeader/SectionHeader';
import { Glyphicon } from 'react-bootstrap';
import Button from 'components/button/Button';
import PropertyEditActionWrapper from 'pages/property/common/PropertyEditActionWrapper';
import useCustomAmenityModal from './modals/useCustomAmenityModal';
import { PROPERTIES_CUSTOM_AMENITIES_BASE_QUERY_KEY } from './useCustomAmenitiesData';

const CustomAmenitiesHeader = () => {
  const { openAddModal } = useCustomAmenityModal();
  const amountOfCustomAmenitiesQueries = useIsFetching({
    queryKey: [PROPERTIES_CUSTOM_AMENITIES_BASE_QUERY_KEY],
  });
  const isFetchingCustomAmenities = amountOfCustomAmenitiesQueries > 0;

  const handleNewItem = () => {
    openAddModal();
  };

  const { t } = useTranslation();

  return (
    <SectionHeader
      id="custom-amenities"
      title={t('pageProperty.amenities.customAmenities.title')}
      buttons={
        <PropertyEditActionWrapper tooltipId="custom-amenities-button-tooltip">
          <Button
            bsStyle="primary"
            data-testid="custom-amenities-button"
            disabled={isFetchingCustomAmenities}
            onClick={handleNewItem}
          >
            <Glyphicon glyph="plus" />
            {t('pageProperty.amenities.customAmenities.add')}
          </Button>
        </PropertyEditActionWrapper>
      }
      tooltip={t('pageProperty.amenities.customAmenities.tooltip')}
    />
  );
};

export default CustomAmenitiesHeader;
